import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Choice, CommandConfig, Hardware } from '@mri/types';
import { map, mergeMap, Observable, Subscription, tap } from 'rxjs';
import { GenericResourceService } from '@mri/app/resources';
import { ChoiceTypes } from '@mri/enums';
import { CardComponent } from '../../@theme/components/card/card.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FieldCodeModule } from '../inputs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FindOfArrayPipe } from '../../pipes';
import { ClipboardPaneComponent } from '../clipboard-pane';

@Component({
  selector: 'app-commands-config',
  standalone: true,
  imports: [
    CardComponent,
    MatSlideToggleModule,
    MatButtonModule,
    FieldCodeModule,
    FindOfArrayPipe,
    ClipboardPaneComponent
  ],
  templateUrl: './commands-config.component.html',
  styleUrl: './commands-config.component.scss'
})
export class CommandsConfigComponent implements OnInit, OnDestroy {
  private _subscription = new Subscription();

  valueRecord?: CommandConfig[];
  commands?: Choice[];
  isSubmitting: boolean;
  hardware?: Hardware;
  options = {
    lineNumbers: true,
    mode: { name: 'twig', base: 'text/html' }
  };
  channelKeys: Array<'tcp' | 'sms'> = ['tcp', 'sms'];

  @Input()
  hardwareId: string;


  constructor(
    private _genericSrcSrv: GenericResourceService,
    private _snackBar: MatSnackBar,
    private _cv: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this._subscription.add(
      this._brigHardware().pipe(
        mergeMap(() => this._brigCommands()),
        tap(() => this._organizeData()),
        tap(() => this._cv.detectChanges()),
        tap(() => this._cv.markForCheck())
      ).subscribe()
    );
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  onSubmit() {
    const hardware = this.hardware;
    Object.assign(hardware?.config || {}, { commands: this.valueRecord });

    this.isSubmitting = true;
    this._subscription.add(
      this._genericSrcSrv
        .putElement(`hardware/${this.hardwareId}`, hardware)
        .pipe(
          tap(() => this.isSubmitting = false),
          tap(() => this._snackBar.open('Configuracion guardada correctamente!'))
        ).subscribe()
    );
  }

  private _brigHardware(): Observable<Hardware> {
    return this._genericSrcSrv
      .getElement<Hardware>('hardware', this.hardwareId)
      .pipe(
        map(({ object }) => object),
        tap(hardware => this.hardware = hardware),
        tap(hardware => this.valueRecord = Array.isArray(hardware.config?.commands) ? hardware.config?.commands : [])
      );
  }


  private _brigCommands(): Observable<Array<Choice>> {
    return this._genericSrcSrv
      .getElements<Choice>(
        'choices',
        { paginate: { page: 1, size: 99 }, filter: { fieldKey: ChoiceTypes.COMMAND } }
      )
      .pipe(
        map(({ objects }) => objects),
        tap(commands => this.commands = commands)
      );
  }

  private _organizeData() {
    this.valueRecord = (this.commands || [])
      .map(command => {
        const value = this.hardware?.config?.commands;
        const config = (Array.isArray(value) ? value : []).find(c => c.key === command.value)  ;

        const configResult: CommandConfig = {
          ...(config || { channels: [] }),
          key: command.value,
        };

        configResult.channels = this.channelKeys.map( channelKey => {
          const channelConfig = configResult.channels.find( c => c.key === channelKey);

          return {
            custom: '',
            enable: false,
            isCustom: false,
            ...(channelConfig || {}),
            key: channelKey,
          }
        })

        return configResult;
      });
  }
}
